export default __webpack_public_path__ + "static/media/Run (2).fbe82bd0.png";